import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';

const defaultState = {
  guides: []
};

class GuideStore extends ImmutableStore {
  static storeName = 'GuideStore';

  static handlers = {
    [Actions.GUIDES__ALL_GUIDES_LOADED]: 'receiveGuides',
    [Actions.GUIDES__GUIDE_LOADED]: 'setActiveGuide',
    [Actions.GUIDES__DOMAIN_VALIDATION_COMPLETED]: 'setDomainValid'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  receiveGuides(guides) {
    this.mergeState({
      guides
    });
  }

  getGuides() {
    return this.get('guides').toJS();
  }

  getActiveGuides() {
    return this.get('guides').filter(g => g.get('active')).toJS();
  }

  setActiveGuide(activeGuide = {}) {
    this.mergeState({
      activeGuide
    });
  }

  setDomainValid({valid: domainValid}) {
    this.mergeState({
      domainValid
    });
  }

  getActiveGuide() {
    const activeGuide = this.get('activeGuide');

    return activeGuide ? activeGuide.toJS() : {};
  }

  domainValid() {
    return this.get('domainValid');
  }
}

export default GuideStore;



// WEBPACK FOOTER //
// ./src/stores/GuideStore.js